import MappingsFieldInternal, { componentName } from './MappingsFieldInternal';

customElements.define(componentName, MappingsFieldInternal);
